export const _imageRestrictions = {
    minWidth: 64,
    minHeight: 64,
    maxKb: 1024
}